import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const KEY = "dhannniti_preloader_seen";

export default function Preloader() {
    const [visible, setVisible] = useState(true);

    useEffect(() => {
        // Show only once per session
        if (sessionStorage.getItem(KEY)) {
            setVisible(false);
            return;
        }
        const t = setTimeout(() => {
            setVisible(false);
            sessionStorage.setItem(KEY, "1");
        }, 2200);
        return () => clearTimeout(t);
    }, []);

    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    initial={{ opacity: 1 }}
                    exit={{
                        y: "-100%",
                        transition: {
                            duration: 1.1,
                            ease: [0.85, 0, 0.15, 1],
                        },
                    }}
                    className="fixed inset-0 z-[100] bg-[#0D1B1A] text-[#FDFAF5] flex items-center justify-center overflow-hidden"
                >
                    {/* grain */}
                    <div
                        className="absolute inset-0 opacity-[0.08] pointer-events-none"
                        style={{
                            backgroundImage:
                                "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='240' height='240'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2' stitchTiles='stitch'/></filter><rect width='100%25' height='100%25' filter='url(%23n)'/></svg>\")",
                        }}
                    />
                    <div className="relative text-center">
                        <div className="text-[10px] tracking-[0.4em] uppercase text-[#9FB1AE]">
                            <motion.span
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{ duration: 0.6, delay: 0.1 }}
                            >
                                Wealth · Strategy · Debt-free
                            </motion.span>
                        </div>
                        <div className="mt-8 overflow-hidden">
                            <motion.div
                                initial={{ y: "100%" }}
                                animate={{ y: "0%" }}
                                transition={{
                                    duration: 1.0,
                                    delay: 0.3,
                                    ease: [0.16, 1, 0.3, 1],
                                }}
                                className="font-serif text-6xl md:text-8xl font-light"
                                style={{ fontFamily: "Fraunces, serif" }}
                            >
                                Dhan
                                <span className="text-[#D4944C] italic">
                                    Nniti
                                </span>
                            </motion.div>
                        </div>
                        <motion.div
                            initial={{ scaleX: 0 }}
                            animate={{ scaleX: 1 }}
                            transition={{ duration: 1.6, delay: 0.4 }}
                            className="mt-10 mx-auto h-px w-40 bg-[#D4944C]/60 origin-left"
                        />
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
